import $ from 'jquery';
import Cookies from 'js-cookie';
import MomentFactory from '../common/moment/MomentFactory';
import VcomProvider from '../VcomProvider';

export default function LanguageSwitch() {
  let sCurrentLanguage = '';
  let sCurrentLocale = '';

  function requestLanguageSwitch(lang) {
    if ((!lang) || (lang === '')) {
      return;
    }
    $.ajax({
      type: 'POST',
      url: `${VcomProvider.baseUrl}/default/index/switchlang`,
      data: {
        sLang: lang,
      },
      success(data) {
        if (data && data.error) {
          return;
        }
        window.location.reload(true);
      },
    });
  }

  function getCurrentLocale() {
    return sCurrentLocale || Cookies.get('locale');
  }

  return {
    init(lang, locale) {
      Cookies.set('lang', lang, { sameSite: 'Lax', secure: 'true' });
      Cookies.set('locale', locale, { sameSite: 'Lax', secure: 'true' });
      sCurrentLanguage = lang;
      sCurrentLocale = locale;
      MomentFactory.locale(getCurrentLocale().replace(/zh_HANS/, 'zh_CN'));
    },
    switchLang(lang) {
      requestLanguageSwitch(lang);
    },
    getCurrentLanguage() {
      return sCurrentLanguage || Cookies.get('lang');
    },
    getCurrentLocale,
  };
}
